import { render, staticRenderFns } from "./SettingVarious.vue?vue&type=template&id=cd6cbbdc&scoped=true"
import script from "./SettingVarious.vue?vue&type=script&lang=js"
export * from "./SettingVarious.vue?vue&type=script&lang=js"
import style0 from "./SettingVarious.vue?vue&type=style&index=0&id=cd6cbbdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6cbbdc",
  null
  
)

export default component.exports